import axios from 'axios'
const uri = 'libreta-direcciones/php/'

const post = (url, data) => {
	return axios.post(uri + url, data)
}

const get = (url) => {
	return axios.get(uri + url)
}

export default {
	buscarRegistros (filtro) {
		return post('buscaRegistros.php', filtro)
	},
	getRegistro (idRegistro) {
		return get('getRegistro.php?ID_registro=' + idRegistro)
	},
	getLibretas (escritura) {
		if (escritura !== undefined && escritura === true) {
			return get('getLibretas.php?escritura=true')
		} else {
			return get('getLibretas.php')
		}
	},
	getLibreta (idLibreta) {
		return post('getLibreta.php', {ID_libreta: idLibreta})
	},
	setLibreta (datos) {
		return post('setLibreta.php', datos)
	},
	eliminarLibreta (idLibreta) {
		return post('delLibreta.php', {ID_libreta: idLibreta})
	},
	setRegistro (datos) {
		return post('setRegistro.php', datos)
	},
	eliminar (idRegistro) {
		return post('delRegistro.php', {ID_registro: idRegistro})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/libreta-direcciones/vue/service.js